/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import SourceForm from "./SourceForm";
import { editSource, getSourceById, getSourceDataBySourceId, getSourcePreviewBySourceId } from "./sourceSlice";
import SpinnerOverlay from "../../common/components/SpinnerOverlay";
import Container from "../../common/components/layout/Container";
import Panel from "../../common/components/layout/Panel";

const EditSourceContainer = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id: sourceId } = useParams();
    const sourceState = useSelector(state => state.source);

    // Fetch the source, sourceData, and preview when component mounts
    useEffect(() => {
        if (sourceId) {
            dispatch(getSourceById(sourceId));
            dispatch(getSourceDataBySourceId(sourceId));
            dispatch(getSourcePreviewBySourceId(sourceId));
        }
    }, [dispatch, sourceId]);

    const breadcrumbItems = [
        { label: 'Home', href: '/admin/home', isActive: false },
        { label: 'Sources', href: '/admin/sources', isActive: false },
        { label: 'Edit Source', href: '', isActive: true }
    ];

    const handleCancel = () => {
        navigate('/admin/sources');
    };

    const handleSave = (data) => {
        dispatch(editSource({ id: sourceId, data }));
    };

    // Show loading state while fetching source
    if (!sourceState.managedSource && sourceState.loading) {
        return (
            <Container>
                <Panel>
                    <SpinnerOverlay />
                </Panel>
            </Container>
        );
    }

    // Show error if source not found
    if (!sourceState.managedSource && !sourceState.loading) {
        return (
            <Container>
                <Panel>
                    <div>Source not found</div>
                </Panel>
            </Container>
        );
    }

    return (
        <SourceForm
            mode="edit"
            initialData={sourceState.managedSource}
            sourceData={sourceState.sourceData}
            sourcePreview={sourceState.sourcePreview}
            onSave={handleSave}
            onCancel={handleCancel}
            breadcrumbItems={breadcrumbItems}
            loading={sourceState.loading}
            alertMessage={{text: sourceState.alertMessage, id: Date.now()}}
            successMessage={{text: sourceState.successMessage, id: Date.now()}}
        />
    );
};

export default EditSourceContainer;
